<template>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addPost"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editPost(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deletePost(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshPostList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
    <el-table
      :data="postList"
      height="100%"
      row-key="id"
      size="small"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        type="selection"
        width="55"
      > </el-table-column>
      <el-table-column
        align="left"
        prop="postName"
        label="岗位名称"
        width="180"
      > </el-table-column>

      <el-table-column
        align="center"
        label="是否可用"
        width="120"
      >
        <template slot-scope="scop">
          <el-tag
            size="normal"
            effect="light"
            v-if="scop.row.status == 1"
          >正常</el-tag>
          <el-tag
            type="danger"
            size="normal"
            effect="light"
            v-if="scop.row.status == 0"
          >禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sort"
        label="岗位排序"
      >
        <template slot-scope="scop">
          <el-input-number
            style="width:150px"
            v-model="scop.row.sort"
            @change="changeSort(scop.row)"
            size="small"
            label=""
            :min="1"
            :max="1000"
            :step="1"
            :controls="true"
            controls-position="both"
          >
          </el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="remarks"
        label="备注信息"
        width="180"
      > </el-table-column>

      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkPost(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editPost(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deletePost(scop.row.id)">
              <Icon
                size="16"
                style="color: red"
              >
                <Delete24Regular />
              </Icon>
              <span
                class="operation-label"
                style="color: red"
              >删除</span>
            </div>
            <div>
              <Icon size="16">
                <Person24Filled />
              </Icon>
              <span
                class="operation-label"
                @click="postUser(scop.row)"
              >分配用户</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改岗位信息 -->
    <el-dialog
      :title="postStates[postState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="post"
          ref="postForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="mini"
        >
          <el-form-item
            label="岗位名称"
            prop="postName"
          >
            <el-input
              style="width: 200px"
              size="small"
              v-model="post.postName"
              :disabled="postState == 'check'"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="岗位排序"
            prop="sort"
          >
            <el-input-number
              size="small"
              style="width: 200px"
              v-model="post.sort"
              :disabled="postState == 'check'"
              :min="1"
              :max="100"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="是否可用"
            prop="status"
          >
            <el-select
              style="width: 200px"
              size="small"
              v-model="post.status"
              :disabled="postState == 'check'"
            >
              <el-option
                label="正常"
                :value="1"
              > </el-option>
              <el-option
                label="禁用"
                :value="0"
              > </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              style="width: 200px"
              size="small"
              type="textarea"
              :rows="2"
              v-model="post.remarks"
              :disabled="postState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="postState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
    <PostUser
      ref="postUser"
      :post="currentPost"
    />
  </div>
</template>

<script>
import PostUser from '@/components/organization/PostUser.vue';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, Person24Filled } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Person24Filled,
        PostUser,
        Search
    },
    props: {
        checkState: String,
        queryForm: Object,
        resetCheckState: Function
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetPostList();
                this.getPostList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetPostList();
                this.getPostList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            loading: false,
            showDialog: false,
            isImportDate: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentPost: {},
            currentUserId: '',
            postState: 'add',
            postStates: {
                add: '新建岗位',
                check: '查看岗位',
                edit: '修改岗位'
            },
            multipleSelection: [],
            postList: [],
            isSearch: '',
            post: {
                postName: '', //岗位名称
                type: '',
                sort: 10,
                remarks: '',
                status: 1
            },
            btnLoading: false,

            rules: {
                postName: [{ required: true, message: '岗位不能为空', trigger: 'blur' }],
                type: [{ required: true, message: '岗位类型不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '岗位排序不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '岗位是否可用不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getPostList();
    },
    methods: {
      search(){
        this.isSearch = ! this.isSearch;
        this.$emit('send',this.isSearch);
      },
        postUser(post) {
            this.currentPost = post;
            setTimeout(() => {
                this.$refs.postUser.init();
            }, 200);
        },
        resetPostList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.postList = [];
        },
        resetDialog() {
            this.$refs.postForm.resetFields();
            this.postState = 'add';
            this.showDialog = false;
            this.post = {
                postName: '', //岗位名称
                type: '',
                sort: 1,
                remarks: '',
                status: 1
            };
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.postState == 'add') {
                this.$refs.postForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/post/add`, { ...this.post }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetPostList();
                                this.resetDialog();
                                this.getPostList();
                            }
                        });
                    }
                });
            } else if (this.postState == 'edit') {
                this.$refs.postForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/post/edit`, { ...this.post }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetPostList();
                                this.resetDialog();
                                this.getPostList();
                            }
                        });
                    }
                });
            }
        },
        addPost() {
            this.showDialog = true;
            this.postState = 'add';
        },
        checkPost(postId) {
            console.log(postId);
            this.currentPostId = postId;

            this.getPostById();
            this.showDialog = true;
            this.postState = 'check';
        },
        editPost(postId) {
            console.log('post', postId);
            if (postId) {
                this.currentPostId = postId;
                this.getPostById();
            } else {
                this.post = { ...this.post, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.postState = 'edit';
        },
        deletePost(postId) {
            let ids = '';
            if (postId) {
                ids = postId;
            } else {
                ids = this.multipleSelection.map((post) => post.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/post/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetPostList();
                            this.getPostList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshPostList() {
            this.resetPostList();
            this.getPostList();
        },
        getPostList(query = {}) {
            this.loading = true;
            get(`/mpp/post/findList`, { ...query, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.postList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getPostById() {
            get(`/mpp/post/get`, { id: this.currentPostId }).then((res) => {
                if (res.success) {
                    this.post = { ...this.post, ...res.mppPost };
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportPostList() {
            this.btnLoading = true;
            exprotExcel(`/mpp/post/export`, this.post, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/post/importTemplate`, this.btnLoading);
        },

        isImport() {
            this.isImportDate = !this.isImportDate ? true : false;
        },
        /**
         * 导入数据
         */
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/post/importData`, formData);
            this.refreshPostList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getPostList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getPostList();
        },
        changeSort(postData) {
            post(`/mpp/post/edit`, { ...postData }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.getPostList();
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
